import { LAST_ROUTE_STORAGE_KEY } from './navigation';

export const AUTH_TOKEN_KEY = 'crickarena_auth_token';
export const TOKEN_EXPIRY_LEEWAY_MS = 60 * 1000;

const LOCAL_STORAGE_AUTH_KEYS = [AUTH_TOKEN_KEY, 'accessToken', 'refreshToken', 'jwt', 'token'];
const SESSION_STORAGE_AUTH_KEYS = [...LOCAL_STORAGE_AUTH_KEYS, LAST_ROUTE_STORAGE_KEY];

export const clearWebAuthSession = () => {
  LOCAL_STORAGE_AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
  SESSION_STORAGE_AUTH_KEYS.forEach((key) => sessionStorage.removeItem(key));
};

const decodeTokenPayload = (token) => {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    const normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
    const payload = atob(padded);
    return JSON.parse(payload);
  } catch {
    return null;
  }
};

export const isTokenExpired = (token, options = {}) => {
  const payload = decodeTokenPayload(token);
  if (!payload?.exp) {
    return false;
  }

  const leewayMs = Number.isFinite(options.leewayMs) ? Number(options.leewayMs) : TOKEN_EXPIRY_LEEWAY_MS;
  return payload.exp * 1000 < Date.now() - leewayMs;
};

export const isUnauthorizedStatus = (status) => status === 401;

export const isTokenInvalidError = (payload = {}, fallbackMessage = '') => {
  const source = [payload?.error, payload?.message, fallbackMessage]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (!source) {
    return false;
  }

  return ['token', 'jwt', 'expired', 'unauthorized', 'invalid', 'signature']
    .some((segment) => source.includes(segment));
};
